module.exports = __webpack_public_path__ + "img/collepardo_hero_card.1f20e1b7.png";